"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var u, s;
function O() {
  if (s) return u;
  s = 1;
  var f = Object.getOwnPropertySymbols, b = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
  function j(n) {
    if (n == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(n);
  }
  function p() {
    try {
      if (!Object.assign)
        return !1;
      var n = new String("abc");
      if (n[5] = "de", Object.getOwnPropertyNames(n)[0] === "5")
        return !1;
      for (var o = {}, r = 0; r < 10; r++)
        o["_" + String.fromCharCode(r)] = r;
      var a = Object.getOwnPropertyNames(o).map(function(t) {
        return o[t];
      });
      if (a.join("") !== "0123456789")
        return !1;
      var e = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(t) {
        e[t] = t;
      }), Object.keys(Object.assign({}, e)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return u = p() ? Object.assign : function(n, o) {
    for (var r, a = j(n), e, t = 1; t < arguments.length; t++) {
      r = Object(arguments[t]);
      for (var c in r)
        b.call(r, c) && (a[c] = r[c]);
      if (f) {
        e = f(r);
        for (var i = 0; i < e.length; i++)
          l.call(r, e[i]) && (a[e[i]] = r[e[i]]);
      }
    }
    return a;
  }, u;
}
export {
  O as __require
};
//# sourceMappingURL=index.es524.js.map
